import { Emitter, Event } from "../../../../../features/event-emitter"
import { ModalId, showErrorStrToast, useUIActions } from "../../../../../features/ui"
import { SalePaymentItemData } from "../../../../sales"
import { useCreditPaymentHooks } from "../../../hooks/creditPaymentHooks"
import { useCreditPaymentService } from "../../../services/creditPaymentService"

export const useActions = () => {
    const { getCustomerDebtData } = useCreditPaymentHooks()

    const { confirmCreditPayment } = useCreditPaymentService()

    const { closeModal } = useUIActions()

    const validateDebt = async (
        customerId: string,
        debt: number
    ) => {
        const loadedDebtData = await getCustomerDebtData(customerId, true)
        if (loadedDebtData.debt !== debt) {
            return 'La deuda total del cliente cambió desde que se cargó la información. Actualice la dueda para confirmar el cobro.'
        }
    }

    const submitCreditPayment = async (
        customerId: string,
        paymentDate: Date,
        salePaymentItem: SalePaymentItemData
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        try {
            const { accreditationFailed } = await confirmCreditPayment(customerId, paymentDate, salePaymentItem)
            Emitter.emit(Event.DB_SUBMIT_DONE, false)
            // El cobro y la imputación ya se guardaron: solo falta el movimiento en la caja
            accreditationFailed && showErrorStrToast('El cobro se registró, pero no se pudo acreditar el pago en la caja. Podés reintentarlo desde el detalle del cobro con "Acreditar en Caja".')
        } catch (error) {
            closeModal(ModalId.SPINNER)
            showErrorStrToast('No se pudo registrar el cobro. Revisá la cuenta corriente antes de volver a intentarlo.')
        }
    }

    return {
        validateDebt,
        submitCreditPayment
    }
}
